export const THEME = {
  MINI_SIDENAV: "MINI_SIDENAV",
  TRANSPARENT_SIDENAV: "TRANSPARENT_SIDENAV",
  SIDENAV_COLOR: "SIDENAV_COLOR",
  TRANSPARENT_NAVBAR: "TRANSPARENT_NAVBAR",
  FIXED_NAVBAR: "FIXED_NAVBAR",
  OPEN_CONFIGURATOR: "OPEN_CONFIGURATOR",
  DIRECTION: "DIRECTION",
  LAYOUT: "LAYOUT",
};
